function Education() {
  return (
    <section id="contact">
      <h2>Acting Instructor</h2>
      <h3>•  University of Alabama in Huntsville</h3>
      <h3 className="education">•  St. John Paul II Catholic High School</h3>

      <h2>Technical Theatre</h2>
      <h3 className="education">•  St. John Paul II Catholic High School</h3>

      <h2>Children's Theatre</h2>
      <h3>•  Fantasy Playhouse Children's Theatre</h3>
    </section>
  );
}

export default Education;